module.exports = __webpack_public_path__ + "media/images/home/ic_email-ec880a6441b52360ccc4dbdd29378622.svg";